import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { RouteConstant } from 'src/app/core/_constants/route.constant';
import { AdminProfile, APP_CONSTANT } from 'src/app/core/_constants/app.constant';
import { ConfirmDialogComponent } from '../../dialogs/confirm-dialog/confirm-dialog.component';
import { AuthService } from 'src/app/core/_services/pages/auth.service';
import { PagesService } from 'src/app/core/_services/pages/pages.service';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { LocalStorageProvider } from 'src/app/core/_services/common/storage.service';
import { CommonService } from 'src/app/core/_services/common/common.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {
  adminProfile:AdminProfile = {
    firstName: '',
    lastName: '',
    email: '',
    profilePic: ''
  };
  constructor(private route:Router,private dialog: MatDialog,private authService: AuthService,private service : PagesService,private loader: NgxUiLoaderService,private storageService: LocalStorageProvider,private commonService: CommonService ) { }
isShow=false
  ngOnInit(): void {
    this.commonService.currentUser.subscribe(response =>{
      this.adminProfile = response;
    }
    );
    this.adminProfile = this.storageService.getItem('CurrentUser')
  }


  showdropdown(){
    // this.isShow=!this.isShow;
  }
    // open dialog compoent
    openLogoutDialog() {
      // this.showdropdown()
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        maxHeight: '100vh',
        width:'500px',
        data: {
          title: `${APP_CONSTANT.LOGOUT.title}`,
          sayYes: `${APP_CONSTANT.LOGOUT.logout}`,
          sayNo: `${APP_CONSTANT.LOGOUT.cancel}`
        }
      });
      dialogRef.afterClosed().subscribe((confirm: any) => {
        if (confirm !== undefined && confirm !== null && confirm) {
          this.authService.logout();
        }
      });
    }
  showProfile(){
    // this.showdropdown();
    this.route.navigate([`${'/'+ RouteConstant.Profile}`]);
  }

  @HostListener('window:click', ['$event'])
  @HostListener('window:scroll', ['$event'])

  onEvent(event: any) {
    if(event.target.id == 'profile-image' && this.isShow==false ){
      this.isShow = true;
    }else {
      this.isShow = false;
    }
  }
}
